"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathColorStyle = exports.getPathColorValue = void 0;
const lodash_1 = require("lodash");
const theme_1 = require("../../theme");
exports.getPathColorValue = (color) => lodash_1.find(theme_1.PathColors, ({ name }) => name === color) || theme_1.PathColors[0];
exports.getPathColorStyle = (color) => {
    const c = exports.getPathColorValue(color);
    return `rgb(${c.value.join(', ')})`;
};
